export enum MDSShortcutKeyCharacter {
  Command = "Command",
  C = "C",
  Slash = "Slash",
  Hashtag = "Hashtag",
  Period = "Period",
  One = "One",
  Space = "Space",
  Dash = "Dash",
  Pipe = "Pipe",
  Backtick = "Backtick",
  GreaterThan = "GreaterThan",
  Enter = "Enter",
  SquareBracketOpen = "SquareBracketOpen",
  SquareBracketClose = "SquareBracketClose",
  Tab = "Tab",
  Escape = "Escape",
}

export interface MDSShortcutKeyProps {
  character: MDSShortcutKeyCharacter;
  inline?: boolean;
}
